import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, concatMap, filter } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateOwnership } from '../action-creators';
import AppState from '../../state';
import { NewOwnership } from '@services/ownership/types/new-ownership';
import SimpleUser from '@common/types/user/simple-user';
import { NotificationVias } from '@common/types/notifications/notification-vias';
import { ValidOwnershipType } from '@services/ownership/types/valid-ownership-type';
import { CREATE_MERCH_SUCCESS } from '@webapp/store/merch/actions';
import { CreateMerchSuccess } from '@webapp/store/merch/action-creators';

/**
 *
 * This effect creates default Owners after a successful Merch Creation based on the
 *  - Current User
 *  - Main Artists Team
 */
export const createOwnersForNewMerchEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, CreateMerchSuccess>(CREATE_MERCH_SUCCESS),
    withLatestFrom(state$),
    filter(([action]) => !!(action.merch && action.merch.productId)),
    concatMap(([action, state]) => {
      let newOwners: NewOwnership[] = [];

      const merchId = action.merch.productId;
      if (merchId) {
        newOwners = newOwners.concat(getCurrentUser(merchId, state));
        newOwners = newOwners.concat(getTeam(merchId, state));
      }

      return newOwners.map((owner) => new CreateOwnership(owner));
    })
  );

const getCurrentUser = (merchId: string, state: AppState): NewOwnership[] => {
  const userProfile = state.user.profile;
  const authProfile = state.auth.user;

  const email = userProfile?.email || authProfile?.attributes?.email;
  const telephone =
    userProfile?.telephone || authProfile?.attributes?.telephone;

  if (!(email || telephone)) {
    return [];
  }

  return [
    buildOwner(
      'OWNER',
      merchId,
      userProfile?.id as string,
      userProfile?.fullName || email || telephone,
      email || telephone || '',
      email ? 'email' : 'sms'
    ),
  ];
};

const getTeam = (merchId: string, state: AppState): NewOwnership[] => {
  const users: SimpleUser[] = state.artist.activeTeam;

  return users
    .filter(
      (user) =>
        !!(user.email || user.telephone) && user.id !== state.user.profile?.id
    )
    .map((user, index) => [
      buildOwner(
        'OWNER',
        merchId,
        user.id,
        user.fullName || user.email || user.telephone || '',
        user.email || user.telephone || '',
        user.email ? 'email' : 'sms',
        index + 1
      ),
    ])
    .flat();
};

const buildOwner = (
  ownershipType: ValidOwnershipType,
  trackId: string,
  ownerId: string,
  name: string,
  contact: string,
  contactType: NotificationVias,
  order: number = 0
): NewOwnership => ({
  assetId: trackId,
  assetType: 'MERCH',
  ownershipType,
  name,
  contact,
  contactType,
  ownerType: 'USER',
  ownerId,
  split: 0,
  order,
});
